import {getEnvironmentByHost} from './getEnvironmentByHost'

const enviroment = getEnvironmentByHost()

export function getEnv() {
  let LOGGER_DISABLE_ALL = enviroment === 'development'
  let LOGGER_DISABLE_METRIKA = false
  let LOGGER_DISABLE_VENDOREVENT = false
  let LOGGER_DISABLE_RUM = false

  try {
    if (process.env.LOGGER_DISABLE_ALL === 'true') {
      LOGGER_DISABLE_ALL = true
    }
  } catch {
    // noop
  }

  try {
    if (process.env.LOGGER_DISABLE_METRIKA === 'true') {
      LOGGER_DISABLE_METRIKA = true
    }
  } catch {
    // noop
  }

  try {
    if (process.env.LOGGER_DISABLE_VENDOREVENT === 'true') {
      LOGGER_DISABLE_VENDOREVENT = true
    }
  } catch {
    // noop
  }

  try {
    if (process.env.LOGGER_DISABLE_RUM === 'true') {
      LOGGER_DISABLE_RUM = true
    }
  } catch {
    // noop
  }

  return {
    LOGGER_DISABLE_METRIKA: LOGGER_DISABLE_ALL || LOGGER_DISABLE_METRIKA,
    LOGGER_DISABLE_VENDOREVENT: LOGGER_DISABLE_ALL || LOGGER_DISABLE_VENDOREVENT,
    LOGGER_DISABLE_RUM: LOGGER_DISABLE_ALL || LOGGER_DISABLE_RUM
  }
}
